/* eslint-disable no-unused-vars */
import clsx from "clsx";
import {useMemo, useState, useEffect, useCallback} from "react";
import {useHistory} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {BasicTable, SearchBox} from "components/Table";
import {BroadcastButton, ButtonAddTable} from "components/Button";
import {usePatients, useDeletePendaftaranPasien} from "hooks/PendaftaranPasien";
import {ModalConfirmation, ModalResetPassword} from "components/Modal";
import {useToast} from "hooks/useToast";
import {useStateCallback} from "hooks/useStateCallback";
import {convertErrorMessageFormat} from "utils/converter";
import {useDeleteReview, useReview, useSendLinkReview} from "hooks/AdminAdmission/Review";
import {MdContentCopy} from "react-icons/md";

const statusColor = {
	bgColor: {
		pasien: "#c1c1c1",
		belum_dilayani: "#ffa1a1",
		sedang_dilayani: "#ffc2a4",
		menunggu_lab: "#ffc2a4",
		menunggu_pembayaran: "#ffffc0",
		menunggu_obat: "#ffffc0",
		pulang: "#c1ffb6",
	},
	statusText: {
		pasien: "Abu-Abu",
		belum_dilayani: "Merah",
		sedang_dilayani: "Orange Pastel",
		menunggu_lab: "Orange Pastel",
		menunggu_pembayaran: "Kuning Pastel",
		menunggu_obat: "Kuning Pastel",
		pulang: "Hijau",
	},
};

export function ReviewListPage() {
	const {data, isLoading, filter, filterReviews} = useReview();

	const [dataLimit, setDataLimit] = useState(10);
	const [searchKeyword, setSearchKeyword] = useState("");

	// Delete Data State
	const {mutate, isLoading: isDeletingData} = useDeleteReview();
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showInfoModal, setShowInfoModal] = useState(false);
	const [deleteItemData, setDeleteItemData] = useStateCallback({id: null, name: null});
	const {showToast} = useToast();

	const [isOpenShareLink, setIsOpenShareLink] = useState(false);
	const [shareTo, setShareTo] = useState([]);
	const changeShareTo = value => {
		if (shareTo.includes(value)) {
			setShareTo([...shareTo.filter(item => item !== value)]);
		} else {
			setShareTo([...shareTo, value]);
		}
	};
	const [selectedData, setSelectedData] = useState();
	const {mutate: mutateSendLink, isLoading: isLoadingShareLink} = useSendLinkReview(selectedData?.id);
	const handleShareLink = useCallback(() => {
		mutateSendLink(
			{channels: shareTo},
			{
				onSuccess() {
					showToast("success", `Link review berhasil dikirim`, 3000);
				},
				onError(res) {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	}, [mutateSendLink, shareTo, showToast]);

	const history = useHistory();
	const columns = useMemo(
		() => [
			{
				Header: "No",
				accessor: "idSerial",
			},
			// {
			// 	Header: "Patient Status",
			// 	accessor: "patientStatus",
			// 	Cell: ({row}) => {
			// 		return (
			// 			<div
			// 				className="box-status "
			// 				style={{
			// 					background: statusColor.bgColor[row?.original?.patient?.patientStatus],
			// 					color: "#fff",
			// 				}}
			// 			/>
			// 		);
			// 	},
			// },
			{
				Header: "Status Review",
				accessor: "status",
			},
			{
				Header: "Nama Pasien",
				accessor: "patient.fullName",
				Cell: ({row}) => {
					return `${row?.original?.patient?.firstName} ${row?.original?.patient?.lastName}`;
				},
			},
			{
				Header: "Nama Admission Pen-Generate Link",
				accessor: "createdBy.fullName",
				Cell: ({row}) => {
					return row?.original?.createdBy?.fullName;
				},
			},
			{
				Header: "Nomor Telepon Pasien",
				accessor: "patient.phoneNumber",
				Cell: ({row}) => {
					return `+${row?.original?.patient?.phoneNumber}`;
				},
			},
			{
				Header: "Aksi",
				accessor: "id",
				Cell: ({row}) => {
					return (
						<div className="d-flex flex-row align-items-center">
							<a
								class="text-orange wait-pay"
								style={{cursor: "pointer"}}
								onClick={() => history.push(`/admission/review/show/${row?.values?.id}`)}>
								<span class="icon-ico-eye-open ft-18" />
							</a>
							<a
								class="text-orange wait-pay"
								style={{cursor: "pointer"}}
								onClick={() => history.push(`/admission/review/edit/${row?.values?.id}`)}>
								<span class="icon-ico-pencil ft-18" />
							</a>
							<a
								class={clsx("text-orange wait-pay")}
								style={{cursor: "pointer"}}
								onClick={() => {
									setDeleteItemData(row?.original, () => setShowDeleteModal(true));
								}}>
								<span class="icon-ico-delete ft-18" />
							</a>
						</div>
					);
				},
			},
			{
				Header: "Shared Link",
				accessor: "link",
				Cell: ({row}) => {
					return (
						<button
							class="btn btn-outline-secondary ms-3 d-flex align-items-center gap-2"
							type="button"
							onClick={() => {
								// handleShareLink(row?.original?.id);
								setSelectedData(row.original);
								setIsOpenShareLink(true);
							}}>
							<i className="icon-ico-link text-orange" />
							Share Link
						</button>
					);
				},
			},
		],
		[],
	);

	const dataWithIDSerial =
		data?.data?.rows?.map((item, index) => ({
			...item,
			idSerial: (data?.data?.currentPage - 1) * dataLimit + index + 1,
			// withPatientStatus: true,
		})) || [];

	const handleDeleteData = () => {
		mutate(
			{id: deleteItemData.id},
			{
				onSuccess: () => {
					showToast("success", `Data pasien ${deleteItemData?.patient?.fullName} berhasil dihapus`, 3000);
					window.scrollTo(0, 0);
					setShowDeleteModal(false);
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	return (
		<DashboardLayout>
			<>
				{selectedData && (
					<ModalConfirmation
						approveLabel="Kirim"
						description={`Silahkan pilih metode kirim link review?`}
						loading={isLoadingShareLink}
						rejectLabel="Batal"
						visible={isOpenShareLink}
						onApprove={handleShareLink}
						onClose={() => setIsOpenShareLink(false)}
						onReject={() => setIsOpenShareLink(false)}>
						<div className="row mt-4">
							<div className="col-6">
								<div className="d-flex gap-2">
									<input
										checked={shareTo.includes("email")}
										type="checkbox"
										onChange={() => changeShareTo("email")}
									/>{" "}
									<label>Email</label>
								</div>
								<div className="d-flex gap-2 mt-4">
									<input
										checked={shareTo.includes("whatsapp")}
										type="checkbox"
										onChange={() => changeShareTo("whatsapp")}
									/>{" "}
									<label>Whatsapp</label>
								</div>
							</div>
						</div>
					</ModalConfirmation>
				)}
				<ModalConfirmation
					approveLabel="Ya"
					description={`Apakah Anda yakin ingin menghapus data pasien "${deleteItemData?.patient?.fullName}"?`}
					loading={isDeletingData}
					rejectLabel="Batal"
					visible={showDeleteModal}
					onApprove={handleDeleteData}
					onClose={() => setShowDeleteModal(false)}
					onReject={() => setShowDeleteModal(false)}
				/>
				<div class="text-bold text-dark mb-4">Data Pendaftaran Pasien</div>
				<SearchBox
					rightElement={
						<div className="d-flex gap-4">
							<ButtonAddTable
								text="Tambah Pasien"
								onClick={() => history.push("/admission/review/create")}
							/>
						</div>
					}
					onSearch={keyword => {
						setSearchKeyword(keyword);
						filterReviews({...filter, page: 1, limit: dataLimit, search: keyword});
					}}
				/>
				<BasicTable
					columns={columns}
					currentPage={data?.data?.currentPage}
					data={dataWithIDSerial}
					limit={dataLimit}
					loading={isLoading}
					striped={true}
					title="Data Pendaftaran Pasien"
					totalItems={data?.data?.totalItems}
					totalPage={data?.data?.totalPages}
					onLimitChange={limitValue => {
						setDataLimit(limitValue);
						filterReviews({...filter, page: 1, limit: limitValue, search: searchKeyword});
					}}
					onPageChange={selectedPage =>
						filterReviews({...filter, page: selectedPage, limit: dataLimit, search: searchKeyword})
					}
				/>
			</>
		</DashboardLayout>
	);
}
